import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { privateFetch, privateFetchFormData } from "../../utils/fetch";
import { setSnackbar } from "./snackbar.slice";

export const getLoginImage = createAsyncThunk(
  "login/getLoginImage",
  async (_, { dispatch, rejectWithValue, getState }) => {
    try {
      // const privateFetch = publicFetch(getState().user.token);
      const response = await privateFetch.get(
        // `/api/v1/categories?page=1&limit=10`
        `/api/v1/login/image`
      );
      return response.data;
    } catch (error) {
      const responseMessage = error.response.data.message;
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarType: "error",
          snackbarMessage: responseMessage,
        })
      );
      return rejectWithValue(responseMessage);
    }
  }
);

const loginImageSlice = createSlice({
  name: "loginImage",
  initialState: {
    data: [],
    totalCount: 0,
    page: 0,
    status: "",
    editStatus: "",
    message: "",
  },
  extraReducers: {
    [getLoginImage.pending]: (state, action) => {
      state.status = "LOADING";
    },
    [getLoginImage.fulfilled]: (state, { payload }) => {
      state.data = payload.result;
      state.status = "SUCCESS";
    },
    [getLoginImage.rejected]: (state, action) => {
      state.status = "FAILED";
    },
  },
});
export default loginImageSlice.reducer;
